export default __webpack_public_path__ + "static/media/botenlift.8b1788aa.svg";